interface ByCheckBoxOptions {
  whenChecked: "hide" | "show"
  disableInputs: boolean
}

class ByCheckBox {
  private readonly _target: HTMLElement;
  private readonly _checkBox: HTMLInputElement;
  private readonly _whenChecked: "hide" | "show";
  private readonly _disableInputs: boolean;
  constructor(target: HTMLElement, checkBox: HTMLInputElement, { whenChecked, disableInputs }: ByCheckBoxOptions) {
    this._target = target;
    this._checkBox = checkBox;
    this._whenChecked = whenChecked;
    this._disableInputs = disableInputs;
  }

  connect() {
    this._target.querySelectorAll<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>("input,textarea,select")
      .forEach((input) => {
        if (input.disabled) input.dataset.originallyDisabled = "true";
      });
    this._checkBox.addEventListener("change", () => this.onChecked());
    this.onChecked();
  }

  private onChecked() {
    let hide: boolean;
    switch (this._whenChecked) {
      case "hide":
        hide = this._checkBox.checked;
        break;
      case "show":
        hide = !this._checkBox.checked;
        break;
    }
    this._target.classList.toggle("d-none", hide);
    if (this._disableInputs) {
      this._target.querySelectorAll<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>("input,textarea,select")
        .forEach((input) => {
        input.disabled = hide || input.dataset.originallyDisabled === "true";
      });
    }
  }
}

export class ShowByCheckbox extends ByCheckBox {
  constructor(target: HTMLElement, checkbox: HTMLInputElement = null) {
    const checkBoxSelector = target.dataset.showByCheckbox;
    checkbox = checkbox || document.querySelector(checkBoxSelector);

    if (!checkbox) throw `Failed to find checkbox with selector ${checkBoxSelector}`;

    super(target, checkbox, { whenChecked: "show", disableInputs: true });
  }
}

export class HideByCheckbox extends ByCheckBox {
  constructor(target: HTMLElement, checkbox: HTMLInputElement = null) {
    const checkBoxSelector = target.dataset.hideByCheckbox;
    checkbox = checkbox || document.querySelector(checkBoxSelector);

    if (!checkbox) throw `Failed to find checkbox with selector ${checkBoxSelector}`;

    super(target, checkbox, { whenChecked: "hide", disableInputs: false });
  }
}
